import React from 'react';
function smoothScrollToPricing(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  const duration = 1800;
  const startY = window.pageYOffset;
  let startTime: number | null = null;
  const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const getTargetY = () => {
    const cards = document.getElementById('pricing-cards');
    const cta = document.getElementById('pricing-cta');
    const topOffset = 40;
    if (cards) {
      const cardsTopY = cards.getBoundingClientRect().top + window.pageYOffset - topOffset;
      if (cta) {
        const ctaRect = cta.getBoundingClientRect();
        const ctaBottomAbs = ctaRect.bottom + window.pageYOffset;
        const maxYForCtaVisible = ctaBottomAbs - window.innerHeight + 24;
        return Math.max(0, Math.min(cardsTopY, maxYForCtaVisible));
      }
      return cardsTopY;
    }
    const section = document.getElementById('pricing');
    if (section) {
      return section.getBoundingClientRect().top + window.pageYOffset - topOffset;
    }
    return startY;
  };
  const step = (timestamp: number) => {
    if (startTime === null) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeInOutCubic(progress);
    const targetY = getTargetY();
    const distance = targetY - startY;
    window.scrollTo(0, startY + distance * eased);
    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      window.scrollTo({
        top: getTargetY(),
        behavior: 'auto'
      });
    }
  };
  requestAnimationFrame(step);
}
export function HeroSection() {
  return <section className="pt-3 pb-8 px-4 bg-slate-950 text-center" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <div className="flex justify-center mb-4" data-id="element-122">
          <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-orange-500/40 bg-orange-500/5 text-orange-500 md:text-sm font-bold tracking-[0.2em] uppercase text-[7px]" data-id="element-123">
            <span aria-hidden="true" data-id="element-124">💧</span>
            SISTEMA HUMEDAD CERO · MÉTODO DE LOS 4 MÓDULOS
          </span>
        </div>

        <h1 className="md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 tracking-tight text-[25px]" data-id="element-125">
          La Humedad Tiene Solución.{' '}
          <span className="text-orange-500 italic" data-id="element-126">Sin Llamar a Nadie.</span>
        </h1>

        <div className="relative w-full max-w-md mx-auto mb-6" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/d7jAEFhiFwPbdHfeXw4Vue/Diseno_sin_titulo_(8).webp" alt="Sistema Humedad Cero — El sistema N°1 para propietarios argentinos que quieren secar sus paredes para siempre" className="w-full h-auto rounded-2xl shadow-2xl" width={665} height={665} sizes="(max-width: 768px) 90vw, 448px" loading="eager" fetchPriority="high" decoding="sync" data-id="element-128" />
        </div>

        <div data-id="element-129">
          <p className="md:text-2xl text-slate-400 font-medium max-w-2xl mx-auto mb-5 text-[16px]" data-id="element-130">
            Diagnóstico, inyección química, sellado exterior y mantenimiento.{' '}
            <span className="text-orange-500 font-bold italic" data-id="element-131">
              Sin improvisar ni tirar plata en productos que no funcionan.
            </span>
          </p>

          <a href="#pricing" onClick={smoothScrollToPricing} className="inline-flex items-center justify-center gap-3 py-4 px-8 rounded-2xl bg-green-600 hover:bg-green-500 text-white font-black text-lg md:text-xl transition-colors shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.4)] mb-6" data-id="element-132">
            <span className="text-2xl" data-id="element-133">💧</span> → QUIERO MI SISTEMA HUMEDAD
            CERO AHORA
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-slate-400 max-w-2xl mx-auto" data-id="element-134">
            <span className="flex items-center gap-1" data-id="element-135">📄 100% PDF</span>
            <span className="hidden md:inline text-slate-700" data-id="element-136">•</span>
            <span className="flex items-center gap-1" data-id="element-137">⚡ Acceso en 5 min</span>
            <span className="hidden md:inline text-slate-700" data-id="element-138">•</span>
            <span className="flex items-center gap-1" data-id="element-139">🛡️ Garantía 30 días</span>
            <span className="hidden md:inline text-slate-700" data-id="element-140">•</span>
            <span className="flex items-center gap-1" data-id="element-141">
              🏠 +500 casas tratadas
            </span>
            <span className="hidden md:inline text-slate-700" data-id="element-142">•</span>
            <span className="flex items-center gap-1" data-id="element-143">★★★★★ 4.9/5</span>
          </div>
        </div>
      </div>
    </section>;
}